module.exports = __webpack_public_path__ + "static/media/Terrace.0152d921.png";